import { useTranslations } from 'next-intl';
import { CustomImage } from 'components/shared/custom-image/CustomImage';
import { SectionLabel, SectionHeading, SectionBody } from './styleConstants';
import styles from './DesignSection.module.css';

const RING_UNIBODY_IMAGE_PATH = 'web_v2/ring-pro/landing-page/unibody-ring-pro-v2.png';

export const DesignSection = () => {
  const t = useTranslations('ring-pro');

  return (
    <section className={styles.section}>
      <div className={styles.contentContainer}>
        <div className={styles.textContainer}>
          <SectionLabel>{t('ring-pro.design.label')}</SectionLabel>
          <SectionHeading>{t('ring-pro.design.heading')}</SectionHeading>
          <SectionBody>
            {t('ring-pro.design.body')}
          </SectionBody>
        </div>
        <div className={styles.imageWrapper}>
          <CustomImage
            className={styles.ringImage}
            src={RING_UNIBODY_IMAGE_PATH}
            alt={t('ring-pro.design.imageAlt')}
            width={1322}
            height={1279}
          />
        </div>
      </div>
    </section>
  );
};
